import { render, staticRenderFns } from "./page-agenda.vue?vue&type=template&id=731c6a77"
import script from "./page-agenda.vue?vue&type=script&lang=js"
export * from "./page-agenda.vue?vue&type=script&lang=js"
import style0 from "./page-agenda.vue?vue&type=style&index=0&id=731c6a77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports